// src/components/EventMenuComponent.tsx
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './MenuComponent.css'; // Reuse the same styles

interface EventMenuItem {
    id: number;
    titleEn: string;
    titleDa: string;
    image: string;
    link: string;
}

const defaultEventMenuItems: EventMenuItem[] = [
    {
        id: 1,
        titleEn: 'Manage Event',
        titleDa: 'Administrér Event',
        image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/1.png',
        link: '/event/event', // Original Event route
    },
    {
        id: 2,
        titleEn: 'Zones',
        titleDa: 'Zoner',
        image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/8.png',
        link: '/event/zones', // Zones page route
    },
    // Add more event-specific options here
];

interface EventMenuProps {
    eventID?: number; // Optional: append eventID to links
    itemsToShow?: number[];
}

const EventMenuComponent: React.FC<EventMenuProps> = ({ eventID, itemsToShow }) => {
    const { language } = useLanguage();

    const filteredMenuItems = itemsToShow
        ? defaultEventMenuItems.filter((item) => itemsToShow.includes(item.id))
        : defaultEventMenuItems;

    return (
        <div className="menu-grid">
            {filteredMenuItems.map((item) => {
                const link = eventID ? `${item.link}/${eventID}` : item.link;
                return (
                    <div key={item.id} className="menu-card">
                        <a href={link}>
                            <img
                                src={item.image}
                                alt={language === 'da' ? item.titleDa : item.titleEn}
                                className="menu-image"
                            />
                            <div className="menu-title">
                                {language === 'da' ? item.titleDa : item.titleEn}
                            </div>
                        </a>
                    </div>
                );
            })}
        </div>
    );
};

export default EventMenuComponent;
